import { EditorObject } from 'utils/responsiveTypes'

const dashboardBentoBoxes: EditorObject = {
  x: 289.99999999999994,
  y: 129,
  id: '4dnr507iqveay2c4uss3mebdn',
  name: 'Section',
  type: 'LAYOUT_SECTION',
  width: 1222,
  height: 350,
  hidden: false,
  mobile: {
    x: 0,
    y: 20,
    width: 1512,
    height: 346,
    pushGraph: {
      edges: [],
      nodeIds: ['6kxm9ylssq5gy4vuf1zpf1b99'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'CENTER',
    },
  },
  shadow: {
    x: 0,
    y: 2,
    size: 4,
    color: 'rgba(0, 0, 0, 0.2)',
    enabled: false,
  },
  shared: {
    mobile: false,
    tablet: false,
    desktop: false,
  },
  tablet: {
    x: 0,
    y: 20,
    width: 1512,
    height: 346,
    pushGraph: {
      edges: [],
      nodeIds: ['6kxm9ylssq5gy4vuf1zpf1b99'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'CENTER',
    },
  },
  actions: {},
  desktop: {
    x: 0,
    y: 20,
    width: 1512,
    height: 349,
    pushGraph: {
      edges: [],
      nodeIds: ['6kxm9ylssq5gy4vuf1zpf1b99'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'CENTER',
    },
  },
  opacity: 1,
  children: [
    {
      x: 289.99999999999994,
      y: 179,
      id: '6kxm9ylssq5gy4vuf1zpf1b99',
      name: 'Layout Helper',
      type: 'section',
      width: 1222,
      height: 250,
      hidden: false,
      mobile: {
        x: 0,
        y: 38,
        width: 1512,
        height: 310,
        pushGraph: {
          edges: [],
          nodeIds: ['0vsr5yweha47e8tjugsa59sgr'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      shadow: {
        x: 0,
        y: 2,
        size: 4,
        color: 'rgba(0, 0, 0, 0.2)',
        enabled: false,
      },
      shared: {
        mobile: false,
        tablet: true,
        desktop: true,
      },
      tablet: {
        x: 0,
        y: 35,
        width: 1512,
        height: 316,
        pushGraph: {
          edges: [],
          nodeIds: ['0vsr5yweha47e8tjugsa59sgr'],
        },
      },
      actions: {},
      desktop: {
        x: 0,
        y: 36,
        width: 1512,
        height: 317,
        pushGraph: {
          edges: [],
          nodeIds: ['0vsr5yweha47e8tjugsa59sgr'],
        },
      },
      opacity: 1,
      purpose: 'layout_helper',
      children: [
        {
          x: 500.99999999999966,
          y: 179,
          id: '0vsr5yweha47e8tjugsa59sgr',
          name: 'Container',
          type: 'section',
          width: 800.0000000000001,
          height: 250,
          hidden: false,
          mobile: {
            x: 62.03076923076923,
            y: 38,
            width: 1387.9384615384615,
            height: 310,
            pushGraph: {
              edges: [
                {
                  distance: 20.5,
                  endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                  startNodeId: '2k55i71p8182ij11a17y9gjwo',
                },
                {
                  distance: 20.5,
                  endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                  startNodeId: '58tbac6es36m34oxs026u7zc4',
                },
                {
                  distance: 15,
                  endNodeId: '40j9m5i60qhi23mgpt5ik3bje',
                  startNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                },
                {
                  distance: 15,
                  endNodeId: 'eed6lerkta075zjg0c1qqsvea',
                  startNodeId: '40j9m5i60qhi23mgpt5ik3bje',
                },
              ],
              nodeIds: [
                '2k55i71p8182ij11a17y9gjwo',
                '58tbac6es36m34oxs026u7zc4',
                '0iu6lww97ux2zo7wq4r2xet2p',
                '40j9m5i60qhi23mgpt5ik3bje',
                'eed6lerkta075zjg0c1qqsvea',
              ],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          shadow: {
            x: 0,
            y: 2,
            size: 4,
            color: 'rgba(0, 0, 0, 0.2)',
            enabled: false,
          },
          shared: {
            mobile: false,
            tablet: false,
            desktop: false,
          },
          tablet: {
            x: 194.6726618705036,
            y: 35,
            width: 1127.6546762589928,
            height: 316,
            pushGraph: {
              edges: [
                {
                  distance: 20.5,
                  endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                  startNodeId: '2k55i71p8182ij11a17y9gjwo',
                },
                {
                  distance: 20.5,
                  endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                  startNodeId: '58tbac6es36m34oxs026u7zc4',
                },
                {
                  distance: 15,
                  endNodeId: '40j9m5i60qhi23mgpt5ik3bje',
                  startNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                },
                {
                  distance: 15,
                  endNodeId: 'eed6lerkta075zjg0c1qqsvea',
                  startNodeId: '40j9m5i60qhi23mgpt5ik3bje',
                },
              ],
              nodeIds: [
                '2k55i71p8182ij11a17y9gjwo',
                '58tbac6es36m34oxs026u7zc4',
                '0iu6lww97ux2zo7wq4r2xet2p',
                '40j9m5i60qhi23mgpt5ik3bje',
                'eed6lerkta075zjg0c1qqsvea',
              ],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          actions: {},
          desktop: {
            x: 261,
            y: 36,
            width: 989.9999999999998,
            height: 317,
            pushGraph: {
              edges: [
                {
                  distance: 20.5,
                  endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                  startNodeId: '2k55i71p8182ij11a17y9gjwo',
                },
                {
                  distance: 20.5,
                  endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                  startNodeId: '58tbac6es36m34oxs026u7zc4',
                },
                {
                  distance: 15,
                  endNodeId: '40j9m5i60qhi23mgpt5ik3bje',
                  startNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                },
                {
                  distance: 15,
                  endNodeId: 'eed6lerkta075zjg0c1qqsvea',
                  startNodeId: '40j9m5i60qhi23mgpt5ik3bje',
                },
              ],
              nodeIds: [
                '2k55i71p8182ij11a17y9gjwo',
                '58tbac6es36m34oxs026u7zc4',
                '0iu6lww97ux2zo7wq4r2xet2p',
                '40j9m5i60qhi23mgpt5ik3bje',
                'eed6lerkta075zjg0c1qqsvea',
              ],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          opacity: 1,
          purpose: 'container',
          children: [
            {
              x: 500.99999999999966,
              y: 185.5,
              id: '2k55i71p8182ij11a17y9gjwo',
              name: 'Rectangle  30',
              type: 'section',
              width: 386.99999999999955,
              height: 100,
              hidden: false,
              mobile: {
                x: 62.03076923076923,
                y: 44.5,
                width: 671.4152307692299,
                height: 100,
                pushGraph: {
                  edges: [
                    {
                      distance: 3,
                      endNodeId: 'bfhurr4bzobh8pyoil7hvumom',
                      startNodeId: '4342kfyrr5b4trtprvsezv452',
                    },
                  ],
                  nodeIds: [
                    '4342kfyrr5b4trtprvsezv452',
                    'bfhurr4bzobh8pyoil7hvumom',
                  ],
                },
              },
              shadow: {
                x: 0,
                y: 2,
                size: 4,
                color: 'rgba(0, 0, 0, 0.2)',
                enabled: false,
              },
              shared: {
                mobile: true,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 194.6726618705036,
                y: 41.5,
                width: 545.502949640287,
                height: 100,
                pushGraph: {
                  edges: [
                    {
                      distance: 3,
                      endNodeId: 'bfhurr4bzobh8pyoil7hvumom',
                      startNodeId: '4342kfyrr5b4trtprvsezv452',
                    },
                  ],
                  nodeIds: [
                    '4342kfyrr5b4trtprvsezv452',
                    'bfhurr4bzobh8pyoil7hvumom',
                  ],
                },
              },
              actions: {},
              desktop: {
                x: 261,
                y: 42.5,
                width: 478.9124999999992,
                height: 100,
                pushGraph: {
                  edges: [
                    {
                      distance: 3,
                      endNodeId: 'bfhurr4bzobh8pyoil7hvumom',
                      startNodeId: '4342kfyrr5b4trtprvsezv452',
                    },
                  ],
                  nodeIds: [
                    '4342kfyrr5b4trtprvsezv452',
                    'bfhurr4bzobh8pyoil7hvumom',
                  ],
                },
              },
              opacity: 1,
              children: [
                {
                  x: 526.3392857142859,
                  y: 222.5,
                  id: 'bfhurr4bzobh8pyoil7hvumom',
                  name: null,
                  text: '4.5',
                  type: 'label',
                  color: '@text',
                  width: 336.32142857142804,
                  height: 50,
                  hidden: false,
                  mobile: {
                    x: 105.99248076923158,
                    y: 81.5,
                    width: 583.4918076923067,
                    height: 50,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 230.39011690647547,
                    y: 78.5,
                    width: 474.0680395683445,
                    height: 50,
                  },
                  actions: {},
                  desktop: {
                    x: 292.35736607142917,
                    y: 79.5,
                    width: 416.197767857142,
                    height: 50,
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 43,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  // fontWeight: '700',
                  layoutText: ['4.5'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'center',
                },
                {
                  x: 526.3392857142859,
                  y: 199.5,
                  id: '4342kfyrr5b4trtprvsezv452',
                  name: null,
                  text: 'RATING',
                  type: 'label',
                  color: 'rgba(117, 117, 117, 1)',
                  width: 336.32142857142804,
                  height: 20,
                  hidden: false,
                  mobile: {
                    x: 105.99248076923158,
                    y: 58.5,
                    width: 583.4918076923067,
                    height: 20,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 230.39011690647547,
                    y: 55.5,
                    width: 474.0680395683445,
                    height: 20,
                  },
                  actions: {},
                  desktop: {
                    x: 292.35736607142917,
                    y: 56.5,
                    width: 416.197767857142,
                    height: 20,
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 17,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  // fontWeight: 'normal',
                  layoutText: ['STAT 1'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'center',
                  inResponsiveApp: true,
                  calculatedFontFamily:
                    'Inter, -apple-system, "SF Pro Text", sans-serif',
                },
              ],
              pushGraph: {
                edges: [
                  {
                    distance: 3,
                    endNodeId: 'bfhurr4bzobh8pyoil7hvumom',
                    startNodeId: '4342kfyrr5b4trtprvsezv452',
                  },
                ],
                nodeIds: [
                  '4342kfyrr5b4trtprvsezv452',
                  'bfhurr4bzobh8pyoil7hvumom',
                ],
              },
              borderColor: '#BDBDBD',
              borderStyle: 'solid',
              borderWidth: 1,
              positioning: 'fixedTop',
              borderRadius: 9,
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              borderPosition: 'center',
              backgroundColor: '#e0e0e0',
              backgroundStyle: 'none',
            },
            {
              x: 913.9999999999961,
              y: 185.5,
              id: '58tbac6es36m34oxs026u7zc4',
              name: 'Rectangle  31',
              type: 'section',
              width: 386.9999999999985,
              height: 100,
              hidden: false,
              mobile: {
                x: 778.5539999999938,
                y: 44.5,
                width: 671.4152307692281,
                height: 100,
                pushGraph: {
                  edges: [
                    {
                      distance: 3,
                      endNodeId: 'dmdgsf8vj81149zj4mnjz2wi4',
                      startNodeId: '5mdh07i509vndaz6ybwtlafme',
                    },
                  ],
                  nodeIds: [
                    '5mdh07i509vndaz6ybwtlafme',
                    'dmdgsf8vj81149zj4mnjz2wi4',
                  ],
                },
              },
              shadow: {
                x: 0,
                y: 2,
                size: 4,
                color: 'rgba(0, 0, 0, 0.2)',
                enabled: false,
              },
              shared: {
                mobile: true,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 776.8243884892036,
                y: 41.5,
                width: 545.5029496402857,
                height: 100,
                pushGraph: {
                  edges: [
                    {
                      distance: 3,
                      endNodeId: 'dmdgsf8vj81149zj4mnjz2wi4',
                      startNodeId: '5mdh07i509vndaz6ybwtlafme',
                    },
                  ],
                  nodeIds: [
                    '5mdh07i509vndaz6ybwtlafme',
                    'dmdgsf8vj81149zj4mnjz2wi4',
                  ],
                },
              },
              actions: {},
              desktop: {
                x: 772.0874999999955,
                y: 42.5,
                width: 478.912499999998,
                height: 100,
                pushGraph: {
                  edges: [
                    {
                      distance: 3,
                      endNodeId: 'dmdgsf8vj81149zj4mnjz2wi4',
                      startNodeId: '5mdh07i509vndaz6ybwtlafme',
                    },
                  ],
                  nodeIds: [
                    '5mdh07i509vndaz6ybwtlafme',
                    'dmdgsf8vj81149zj4mnjz2wi4',
                  ],
                },
              },
              opacity: 1,
              children: [
                {
                  x: 930.124999999997,
                  y: 222.5,
                  id: 'dmdgsf8vj81149zj4mnjz2wi4',
                  name: null,
                  text: '96',
                  type: 'label',
                  color: '@text',
                  width: 354.74999999999875,
                  height: 50,
                  hidden: false,
                  mobile: {
                    x: 806.5296346153801,
                    y: 81.5,
                    width: 615.4639615384592,
                    height: 50,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 799.5536780575502,
                    y: 78.5,
                    width: 500.04437050359536,
                    height: 50,
                  },
                  actions: {},
                  desktop: {
                    x: 792.0421874999968,
                    y: 79.5,
                    width: 439.00312499999825,
                    height: 50,
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 43,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  // fontWeight: '700',
                  layoutText: ['96'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'center',
                  possibleParent: {
                    x: 290,
                    y: 20,
                    id: '0qgbe4ayv61qgbw899e393zoz',
                    name: 'Rectangle 29',
                    type: 'section',
                    width: 544,
                    height: 1031,
                    hidden: false,
                    mobile: {
                      x: 0,
                      y: 20,
                      width: 834,
                      height: 743,
                      pushGraph: {
                        edges: [
                          {
                            distance: 22,
                          },
                          {
                            distance: 8,
                          },
                          {
                            distance: 18,
                          },
                          {
                            distance: 22,
                          },
                          {
                            distance: 28,
                            endNodeId: '2k55i71p8182ij11a17y9gjwo',
                          },
                          {
                            distance: 28,
                            endNodeId: '58tbac6es36m34oxs026u7zc4',
                          },
                          {
                            distance: 22,
                            endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                            startNodeId: '2k55i71p8182ij11a17y9gjwo',
                          },
                          {
                            distance: 22,
                            endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                            startNodeId: '58tbac6es36m34oxs026u7zc4',
                          },
                          {
                            distance: 15,
                            endNodeId: '40j9m5i60qhi23mgpt5ik3bje',
                            startNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                          },
                          {
                            distance: 15,
                            endNodeId: 'eed6lerkta075zjg0c1qqsvea',
                            startNodeId: '40j9m5i60qhi23mgpt5ik3bje',
                          },
                        ],
                        nodeIds: [
                          null,
                          null,
                          null,
                          null,
                          null,
                          '2k55i71p8182ij11a17y9gjwo',
                          '58tbac6es36m34oxs026u7zc4',
                          '0iu6lww97ux2zo7wq4r2xet2p',
                          '40j9m5i60qhi23mgpt5ik3bje',
                          'eed6lerkta075zjg0c1qqsvea',
                        ],
                      },
                      positioning: 'fixedTop',
                      responsivity: {
                        verticalScaling: 'FIXED',
                        horizontalScaling: 'SCALES_WITH_PARENT',
                        verticalPositioning: 'TOP',
                        horizontalPositioning: 'LEFT_AND_RIGHT',
                      },
                    },
                    shadow: {
                      x: 0,
                      y: 2,
                      size: 4,
                      color: 'rgba(0, 0, 0, 0.2)',
                      enabled: false,
                    },
                    shared: {
                      mobile: false,
                      tablet: false,
                      desktop: false,
                    },
                    tablet: {
                      x: 89,
                      y: 20,
                      width: 745,
                      height: 753,
                      pushGraph: {
                        edges: [
                          {
                            distance: 22,
                          },
                          {
                            distance: 8,
                          },
                          {
                            distance: 18,
                          },
                          {
                            distance: 6,
                          },
                          {
                            distance: 27,
                            endNodeId: '2k55i71p8182ij11a17y9gjwo',
                          },
                          {
                            distance: 27,
                            endNodeId: '58tbac6es36m34oxs026u7zc4',
                          },
                          {
                            distance: 93,
                            endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                          },
                          {
                            distance: 93,
                            endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                            startNodeId: '2k55i71p8182ij11a17y9gjwo',
                          },
                          {
                            distance: 93,
                            endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                            startNodeId: '58tbac6es36m34oxs026u7zc4',
                          },
                          {
                            distance: 15,
                            endNodeId: '40j9m5i60qhi23mgpt5ik3bje',
                            startNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                          },
                          {
                            distance: 15,
                            endNodeId: 'eed6lerkta075zjg0c1qqsvea',
                            startNodeId: '40j9m5i60qhi23mgpt5ik3bje',
                          },
                        ],
                        nodeIds: [
                          null,
                          null,
                          null,
                          null,
                          null,
                          '2k55i71p8182ij11a17y9gjwo',
                          '58tbac6es36m34oxs026u7zc4',
                          '0iu6lww97ux2zo7wq4r2xet2p',
                          '40j9m5i60qhi23mgpt5ik3bje',
                          'eed6lerkta075zjg0c1qqsvea',
                        ],
                      },
                      positioning: 'fixedTop',
                      responsivity: {
                        verticalScaling: 'FIXED',
                        horizontalScaling: 'SCALES_WITH_PARENT',
                        verticalPositioning: 'TOP',
                        horizontalPositioning: 'LEFT_AND_RIGHT',
                      },
                    },
                    actions: {},
                    desktop: {
                      x: 290,
                      y: 20,
                      width: 544,
                      height: 770,
                      pushGraph: {
                        edges: [
                          {
                            distance: 22,
                          },
                          {
                            distance: 8,
                          },
                          {
                            distance: 11,
                          },
                          {
                            distance: 18,
                          },
                          {
                            distance: 40.5,
                            endNodeId: '2k55i71p8182ij11a17y9gjwo',
                          },
                          {
                            distance: 40.5,
                            endNodeId: '58tbac6es36m34oxs026u7zc4',
                          },
                          {
                            distance: 20.5,
                            endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                            startNodeId: '2k55i71p8182ij11a17y9gjwo',
                          },
                          {
                            distance: 20.5,
                            endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                            startNodeId: '58tbac6es36m34oxs026u7zc4',
                          },
                          {
                            distance: 15,
                            endNodeId: '40j9m5i60qhi23mgpt5ik3bje',
                            startNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                          },
                          {
                            distance: 15,
                            endNodeId: 'eed6lerkta075zjg0c1qqsvea',
                            startNodeId: '40j9m5i60qhi23mgpt5ik3bje',
                          },
                        ],
                        nodeIds: [
                          null,
                          null,
                          null,
                          null,
                          null,
                          '2k55i71p8182ij11a17y9gjwo',
                          '58tbac6es36m34oxs026u7zc4',
                          '0iu6lww97ux2zo7wq4r2xet2p',
                          '40j9m5i60qhi23mgpt5ik3bje',
                          'eed6lerkta075zjg0c1qqsvea',
                        ],
                      },
                      positioning: 'fixedTop',
                      responsivity: {
                        verticalScaling: 'FIXED',
                        horizontalScaling: 'SCALES_WITH_PARENT',
                        verticalPositioning: 'TOP',
                        horizontalPositioning: 'LEFT_AND_RIGHT',
                      },
                    },
                    opacity: 1,
                    pushGraph: {
                      edges: [
                        {
                          distance: 22,
                        },
                        {
                          distance: 17,
                        },
                        {
                          distance: 40,
                        },
                        {
                          distance: 74,
                          endNodeId: '2k55i71p8182ij11a17y9gjwo',
                        },
                        {
                          distance: 74,
                          endNodeId: '58tbac6es36m34oxs026u7zc4',
                        },
                        {
                          distance: 36,
                          startNodeId: '2k55i71p8182ij11a17y9gjwo',
                        },
                        {
                          distance: 36,
                          startNodeId: '58tbac6es36m34oxs026u7zc4',
                        },
                        {
                          distance: 31,
                          endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                        },
                        {
                          distance: 15,
                          endNodeId: '40j9m5i60qhi23mgpt5ik3bje',
                          startNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                        },
                        {
                          distance: 18,
                          endNodeId: 'eed6lerkta075zjg0c1qqsvea',
                          startNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                        },
                      ],
                      nodeIds: [
                        null,
                        null,
                        null,
                        null,
                        '2k55i71p8182ij11a17y9gjwo',
                        '58tbac6es36m34oxs026u7zc4',
                        null,
                        '0iu6lww97ux2zo7wq4r2xet2p',
                        '40j9m5i60qhi23mgpt5ik3bje',
                        'eed6lerkta075zjg0c1qqsvea',
                      ],
                    },
                    borderColor: '#757575',
                    borderStyle: 'dashed',
                    borderWidth: 1,
                    positioning: 'fixedTop',
                    borderRadius: 0,
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT_AND_RIGHT',
                    },
                    borderPosition: 'center',
                    backgroundColor: '@background',
                    backgroundStyle: 'color',
                  },
                },
                {
                  x: 962.3749999999956,
                  y: 199.5,
                  id: '5mdh07i509vndaz6ybwtlafme',
                  name: null,
                  text: 'GAMES',
                  type: 'label',
                  color: 'rgba(117, 117, 117, 1)',
                  width: 290.249999999999,
                  height: 20,
                  hidden: false,
                  mobile: {
                    x: 862.4809038461467,
                    y: 58.5,
                    width: 503.5614230769212,
                    height: 20,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 845.0122571942388,
                    y: 55.5,
                    width: 409.1272122302144,
                    height: 20,
                  },
                  actions: {},
                  desktop: {
                    x: 831.9515624999949,
                    y: 56.5,
                    width: 359.18437499999857,
                    height: 20,
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 17,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  // fontWeight: 'normal',
                  layoutText: ['STAT 1'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'center',
                  inResponsiveApp: true,
                  calculatedFontFamily:
                    'Inter, -apple-system, "SF Pro Text", sans-serif',
                },
              ],
              pushGraph: {
                edges: [
                  {
                    distance: 3,
                    endNodeId: 'dmdgsf8vj81149zj4mnjz2wi4',
                    startNodeId: '5mdh07i509vndaz6ybwtlafme',
                  },
                ],
                nodeIds: [
                  '5mdh07i509vndaz6ybwtlafme',
                  'dmdgsf8vj81149zj4mnjz2wi4',
                ],
              },
              borderColor: '#BDBDBD',
              borderStyle: 'solid',
              borderWidth: 1,
              positioning: 'fixedTop',
              borderRadius: 9,
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              borderPosition: 'center',
              backgroundColor: '#e0e0e0',
              backgroundStyle: 'none',
            },
            {
              x: 500.99999999999966,
              y: 306,
              id: '0iu6lww97ux2zo7wq4r2xet2p',
              name: 'Rectangle  32',
              type: 'section',
              width: 799.999999999999,
              height: 48,
              hidden: false,
              mobile: {
                x: 62.03076923076923,
                y: 165,
                width: 1387.9384615384595,
                height: 48,
                pushGraph: {
                  edges: [
                    {
                      distance: 2,
                      endNodeId: '91zs1h8b5atdgg4s7ifltxhjd',
                      startNodeId: 'buffer_91zs1h8b5atdgg4s7ifltxhjd',
                    },
                  ],
                  nodeIds: [
                    '8o8c2cswdbeauo8m3zekrb3nt',
                    'b7s8tc3job31gn6aadbp7gfk3',
                    'buffer_91zs1h8b5atdgg4s7ifltxhjd',
                    '91zs1h8b5atdgg4s7ifltxhjd',
                  ],
                },
              },
              shadow: {
                x: 0,
                y: 2,
                size: 4,
                color: 'rgba(0, 0, 0, 0.2)',
                enabled: false,
              },
              shared: {
                mobile: true,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 194.6726618705036,
                y: 162,
                width: 1127.6546762589912,
                height: 48,
                pushGraph: {
                  edges: [
                    {
                      distance: 2,
                      endNodeId: '91zs1h8b5atdgg4s7ifltxhjd',
                      startNodeId: 'buffer_91zs1h8b5atdgg4s7ifltxhjd',
                    },
                  ],
                  nodeIds: [
                    '8o8c2cswdbeauo8m3zekrb3nt',
                    'b7s8tc3job31gn6aadbp7gfk3',
                    'buffer_91zs1h8b5atdgg4s7ifltxhjd',
                    '91zs1h8b5atdgg4s7ifltxhjd',
                  ],
                },
              },
              actions: {},
              desktop: {
                x: 261,
                y: 163,
                width: 989.9999999999983,
                height: 48,
                pushGraph: {
                  edges: [
                    {
                      distance: 2,
                      endNodeId: '91zs1h8b5atdgg4s7ifltxhjd',
                      startNodeId: 'buffer_91zs1h8b5atdgg4s7ifltxhjd',
                    },
                  ],
                  nodeIds: [
                    '8o8c2cswdbeauo8m3zekrb3nt',
                    'b7s8tc3job31gn6aadbp7gfk3',
                    'buffer_91zs1h8b5atdgg4s7ifltxhjd',
                    '91zs1h8b5atdgg4s7ifltxhjd',
                  ],
                },
              },
              opacity: 1,
              children: [
                {
                  x: 551.9999999999997,
                  y: 320,
                  id: '91zs1h8b5atdgg4s7ifltxhjd',
                  name: null,
                  text: 'Teams',
                  type: 'label',
                  color: '@text',
                  width: 674.999999999999,
                  height: 20,
                  hidden: false,
                  mobile: {
                    x: 113.03076923076924,
                    y: 179,
                    width: 1262.9384615384595,
                    height: 20,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 245.6726618705036,
                    y: 176,
                    width: 1002.6546762589912,
                    height: 20,
                  },
                  actions: {},
                  desktop: {
                    x: 312,
                    y: 177,
                    width: 864.9999999999983,
                    height: 20,
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 17,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  // fontWeight: 'normal',
                  layoutText: ['STAT 1'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'LEFT_AND_RIGHT',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                  inResponsiveApp: true,
                  calculatedFontFamily:
                    'Inter, -apple-system, "SF Pro Text", sans-serif',
                },
                {
                  x: 513.9999999999997,
                  y: 318,
                  id: '8o8c2cswdbeauo8m3zekrb3nt',
                  name: 'Icon 14',
                  type: 'libraryComponent',
                  width: 24,
                  height: 24,
                  hidden: false,
                  mobile: {
                    x: 75.03076923076924,
                    y: 177,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 207.6726618705036,
                    y: 174,
                  },
                  actions: {},
                  desktop: {
                    x: 274,
                    y: 175,
                  },
                  opacity: 1,
                  children: [],
                  attributes: {
                    iconName: 'group',
                    iconSize: 24,
                    iconColor: '#666666',
                  },
                  libraryName: '@protonapp/material-components',
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'FIXED',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'LEFT',
                  },
                  componentName: 'Icon',
                  initialDevice: 'desktop',
                  libraryVersion: '0.9.46',
                },
                {
                  x: 1270.0000000000005,
                  y: 318,
                  id: 'b7s8tc3job31gn6aadbp7gfk3',
                  name: 'Icon  15',
                  type: 'libraryComponent',
                  width: 24,
                  height: 24,
                  hidden: false,
                  mobile: {
                    x: 1418.9692307692308,
                    y: 177,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 1291.3273381294969,
                    y: 174,
                  },
                  actions: {},
                  desktop: {
                    x: 1220.0000000000002,
                    y: 175,
                  },
                  opacity: 1,
                  children: [],
                  attributes: {
                    iconName: 'keyboard-arrow-right',
                    iconSize: 24,
                    iconColor: '#666666',
                  },
                  libraryName: '@protonapp/material-components',
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'FIXED',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'RIGHT',
                  },
                  componentName: 'Icon',
                  initialDevice: 'desktop',
                  libraryVersion: '0.9.46',
                },
              ],
              pushGraph: {
                edges: [
                  {
                    distance: 2,
                    endNodeId: '91zs1h8b5atdgg4s7ifltxhjd',
                    startNodeId: 'buffer_91zs1h8b5atdgg4s7ifltxhjd',
                  },
                ],
                nodeIds: [
                  '8o8c2cswdbeauo8m3zekrb3nt',
                  'b7s8tc3job31gn6aadbp7gfk3',
                  'buffer_91zs1h8b5atdgg4s7ifltxhjd',
                  '91zs1h8b5atdgg4s7ifltxhjd',
                ],
              },
              borderColor: '#BDBDBD',
              borderStyle: 'solid',
              borderWidth: 1,
              positioning: 'fixed',
              borderRadius: 9,
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              borderPosition: 'center',
              backgroundColor: '#e0e0e0',
              backgroundStyle: 'none',
            },
            {
              x: 500.99999999999966,
              y: 369,
              id: '40j9m5i60qhi23mgpt5ik3bje',
              name: 'Rectangle  33',
              type: 'section',
              width: 799.999999999999,
              height: 48,
              hidden: false,
              mobile: {
                x: 62.03076923076923,
                y: 228,
                width: 1387.9384615384595,
                height: 48,
                pushGraph: {
                  edges: [
                    {
                      distance: 2,
                      endNodeId: '6negck2i39skwbqx1e2oma55m',
                      startNodeId: 'buffer_6negck2i39skwbqx1e2oma55m',
                    },
                  ],
                  nodeIds: [
                    'cah4b6cex28i4dhngw4drp5kp',
                    'c99j5vcntencutah3cpp71sza',
                    'buffer_6negck2i39skwbqx1e2oma55m',
                    '6negck2i39skwbqx1e2oma55m',
                  ],
                },
              },
              shadow: {
                x: 0,
                y: 2,
                size: 4,
                color: 'rgba(0, 0, 0, 0.2)',
                enabled: false,
              },
              shared: {
                mobile: true,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 194.6726618705036,
                y: 225,
                width: 1127.6546762589912,
                height: 48,
                pushGraph: {
                  edges: [
                    {
                      distance: 2,
                      endNodeId: '6negck2i39skwbqx1e2oma55m',
                      startNodeId: 'buffer_6negck2i39skwbqx1e2oma55m',
                    },
                  ],
                  nodeIds: [
                    'cah4b6cex28i4dhngw4drp5kp',
                    'c99j5vcntencutah3cpp71sza',
                    'buffer_6negck2i39skwbqx1e2oma55m',
                    '6negck2i39skwbqx1e2oma55m',
                  ],
                },
              },
              actions: {},
              desktop: {
                x: 261,
                y: 226,
                width: 989.9999999999983,
                height: 48,
                pushGraph: {
                  edges: [
                    {
                      distance: 2,
                      endNodeId: '6negck2i39skwbqx1e2oma55m',
                      startNodeId: 'buffer_6negck2i39skwbqx1e2oma55m',
                    },
                  ],
                  nodeIds: [
                    'cah4b6cex28i4dhngw4drp5kp',
                    'c99j5vcntencutah3cpp71sza',
                    'buffer_6negck2i39skwbqx1e2oma55m',
                    '6negck2i39skwbqx1e2oma55m',
                  ],
                },
              },
              opacity: 1,
              children: [
                {
                  x: 551.9999999999997,
                  y: 383,
                  id: '6negck2i39skwbqx1e2oma55m',
                  name: null,
                  text: 'League Stats',
                  type: 'label',
                  color: '@text',
                  width: 674.999999999999,
                  height: 20,
                  hidden: false,
                  mobile: {
                    x: 113.03076923076924,
                    y: 242,
                    width: 1262.9384615384595,
                    height: 20,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 245.6726618705036,
                    y: 239,
                    width: 1002.6546762589912,
                    height: 20,
                  },
                  actions: {},
                  desktop: {
                    x: 312,
                    y: 240,
                    width: 864.9999999999983,
                    height: 20,
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 17,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  // fontWeight: 'normal',
                  layoutText: ['STAT 1'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'LEFT_AND_RIGHT',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                  inResponsiveApp: true,
                  calculatedFontFamily:
                    'Inter, -apple-system, "SF Pro Text", sans-serif',
                },
                {
                  x: 513.9999999999997,
                  y: 381,
                  id: 'cah4b6cex28i4dhngw4drp5kp',
                  name: 'Icon 14',
                  type: 'libraryComponent',
                  width: 24,
                  height: 24,
                  hidden: false,
                  mobile: {
                    x: 75.03076923076924,
                    y: 240,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 207.6726618705036,
                    y: 237,
                  },
                  actions: {},
                  desktop: {
                    x: 274,
                    y: 238,
                  },
                  opacity: 1,
                  children: [],
                  attributes: {
                    iconName: 'list-alt',
                    iconSize: 24,
                    iconColor: '#666666',
                  },
                  libraryName: '@protonapp/material-components',
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'FIXED',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'LEFT',
                  },
                  componentName: 'Icon',
                  initialDevice: 'desktop',
                  libraryVersion: '0.9.46',
                },
                {
                  x: 1270.0000000000005,
                  y: 381,
                  id: 'c99j5vcntencutah3cpp71sza',
                  name: 'Icon  15',
                  type: 'libraryComponent',
                  width: 24,
                  height: 24,
                  hidden: false,
                  mobile: {
                    x: 1418.9692307692308,
                    y: 240,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 1291.3273381294969,
                    y: 237,
                  },
                  actions: {},
                  desktop: {
                    x: 1220.0000000000002,
                    y: 238,
                  },
                  opacity: 1,
                  children: [],
                  attributes: {
                    iconName: 'keyboard-arrow-right',
                    iconSize: 24,
                    iconColor: '#666666',
                  },
                  libraryName: '@protonapp/material-components',
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'FIXED',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'RIGHT',
                  },
                  componentName: 'Icon',
                  initialDevice: 'desktop',
                  libraryVersion: '0.9.46',
                },
              ],
              pushGraph: {
                edges: [
                  {
                    distance: 2,
                    endNodeId: '6negck2i39skwbqx1e2oma55m',
                    startNodeId: 'buffer_6negck2i39skwbqx1e2oma55m',
                  },
                ],
                nodeIds: [
                  'cah4b6cex28i4dhngw4drp5kp',
                  'c99j5vcntencutah3cpp71sza',
                  'buffer_6negck2i39skwbqx1e2oma55m',
                  '6negck2i39skwbqx1e2oma55m',
                ],
              },
              borderColor: '#BDBDBD',
              borderStyle: 'solid',
              borderWidth: 1,
              positioning: 'fixed',
              borderRadius: 9,
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              borderPosition: 'center',
              backgroundColor: '#e0e0e0',
              backgroundStyle: 'none',
            },
            {
              x: 500.99999999999966,
              y: 432,
              id: 'eed6lerkta075zjg0c1qqsvea',
              name: 'Rectangle  34',
              type: 'section',
              width: 799.999999999999,
              height: 48,
              hidden: false,
              mobile: {
                x: 62.03076923076923,
                y: 291,
                width: 1387.9384615384595,
                height: 48,
                pushGraph: {
                  edges: [
                    {
                      distance: 2,
                      endNodeId: 'csf0lv55sdgrvq7ky8l8n6ypw',
                      startNodeId: 'buffer_csf0lv55sdgrvq7ky8l8n6ypw',
                    },
                  ],
                  nodeIds: [
                    '8yiibjuraa4bu5mwofo2auqd2',
                    '09h0fa96rjgc28dfah87jnt7m',
                    'buffer_csf0lv55sdgrvq7ky8l8n6ypw',
                    'csf0lv55sdgrvq7ky8l8n6ypw',
                  ],
                },
              },
              shadow: {
                x: 0,
                y: 2,
                size: 4,
                color: 'rgba(0, 0, 0, 0.2)',
                enabled: false,
              },
              shared: {
                mobile: true,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 194.6726618705036,
                y: 288,
                width: 1127.6546762589912,
                height: 48,
                pushGraph: {
                  edges: [
                    {
                      distance: 2,
                      endNodeId: 'csf0lv55sdgrvq7ky8l8n6ypw',
                      startNodeId: 'buffer_csf0lv55sdgrvq7ky8l8n6ypw',
                    },
                  ],
                  nodeIds: [
                    '8yiibjuraa4bu5mwofo2auqd2',
                    '09h0fa96rjgc28dfah87jnt7m',
                    'buffer_csf0lv55sdgrvq7ky8l8n6ypw',
                    'csf0lv55sdgrvq7ky8l8n6ypw',
                  ],
                },
              },
              actions: {},
              desktop: {
                x: 261,
                y: 289,
                width: 989.9999999999983,
                height: 48,
                pushGraph: {
                  edges: [
                    {
                      distance: 2,
                      endNodeId: 'csf0lv55sdgrvq7ky8l8n6ypw',
                      startNodeId: 'buffer_csf0lv55sdgrvq7ky8l8n6ypw',
                    },
                  ],
                  nodeIds: [
                    '8yiibjuraa4bu5mwofo2auqd2',
                    '09h0fa96rjgc28dfah87jnt7m',
                    'buffer_csf0lv55sdgrvq7ky8l8n6ypw',
                    'csf0lv55sdgrvq7ky8l8n6ypw',
                  ],
                },
              },
              opacity: 1,
              children: [
                {
                  x: 551.9999999999997,
                  y: 446,
                  id: 'csf0lv55sdgrvq7ky8l8n6ypw',
                  name: null,
                  text: 'Schedule',
                  type: 'label',
                  color: '@text',
                  width: 674.999999999999,
                  height: 20,
                  hidden: false,
                  mobile: {
                    x: 113.03076923076924,
                    y: 305,
                    width: 1262.9384615384595,
                    height: 20,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 245.6726618705036,
                    y: 302,
                    width: 1002.6546762589912,
                    height: 20,
                  },
                  actions: {},
                  desktop: {
                    x: 312,
                    y: 303,
                    width: 864.9999999999983,
                    height: 20,
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 17,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  // fontWeight: 'normal',
                  layoutText: ['STAT 1'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'LEFT_AND_RIGHT',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                  inResponsiveApp: true,
                  calculatedFontFamily:
                    'Inter, -apple-system, "SF Pro Text", sans-serif',
                },
                {
                  x: 513.9999999999997,
                  y: 444,
                  id: '8yiibjuraa4bu5mwofo2auqd2',
                  name: 'Icon 14',
                  type: 'libraryComponent',
                  width: 24,
                  height: 24,
                  hidden: false,
                  mobile: {
                    x: 75.03076923076924,
                    y: 303,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 207.6726618705036,
                    y: 300,
                  },
                  actions: {},
                  desktop: {
                    x: 274,
                    y: 301,
                  },
                  opacity: 1,
                  children: [],
                  attributes: {
                    iconName: 'date-range',
                    iconSize: 24,
                    iconColor: '#666666',
                  },
                  libraryName: '@protonapp/material-components',
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'FIXED',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'LEFT',
                  },
                  componentName: 'Icon',
                  initialDevice: 'desktop',
                  libraryVersion: '0.9.46',
                },
                {
                  x: 1270.0000000000005,
                  y: 444,
                  id: '09h0fa96rjgc28dfah87jnt7m',
                  name: 'Icon  15',
                  type: 'libraryComponent',
                  width: 24,
                  height: 24,
                  hidden: false,
                  mobile: {
                    x: 1418.9692307692308,
                    y: 303,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 1291.3273381294969,
                    y: 300,
                  },
                  actions: {},
                  desktop: {
                    x: 1220.0000000000002,
                    y: 301,
                  },
                  opacity: 1,
                  children: [],
                  attributes: {
                    iconName: 'keyboard-arrow-right',
                    iconSize: 24,
                    iconColor: '#666666',
                  },
                  libraryName: '@protonapp/material-components',
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'FIXED',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'RIGHT',
                  },
                  componentName: 'Icon',
                  initialDevice: 'desktop',
                  libraryVersion: '0.9.46',
                },
              ],
              pushGraph: {
                edges: [
                  {
                    distance: 2,
                    endNodeId: 'csf0lv55sdgrvq7ky8l8n6ypw',
                    startNodeId: 'buffer_csf0lv55sdgrvq7ky8l8n6ypw',
                  },
                ],
                nodeIds: [
                  '8yiibjuraa4bu5mwofo2auqd2',
                  '09h0fa96rjgc28dfah87jnt7m',
                  'buffer_csf0lv55sdgrvq7ky8l8n6ypw',
                  'csf0lv55sdgrvq7ky8l8n6ypw',
                ],
              },
              borderColor: '#BDBDBD',
              borderStyle: 'solid',
              borderWidth: 1,
              positioning: 'fixed',
              borderRadius: 9,
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              borderPosition: 'center',
              backgroundColor: '#e0e0e0',
              backgroundStyle: 'none',
            },
          ],
          pushGraph: {
            edges: [
              {
                distance: 20.5,
                endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                startNodeId: '2k55i71p8182ij11a17y9gjwo',
              },
              {
                distance: 20.5,
                endNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
                startNodeId: '58tbac6es36m34oxs026u7zc4',
              },
              {
                distance: 15,
                endNodeId: '40j9m5i60qhi23mgpt5ik3bje',
                startNodeId: '0iu6lww97ux2zo7wq4r2xet2p',
              },
              {
                distance: 15,
                endNodeId: 'eed6lerkta075zjg0c1qqsvea',
                startNodeId: '40j9m5i60qhi23mgpt5ik3bje',
              },
            ],
            nodeIds: [
              '2k55i71p8182ij11a17y9gjwo',
              '58tbac6es36m34oxs026u7zc4',
              '0iu6lww97ux2zo7wq4r2xet2p',
              '40j9m5i60qhi23mgpt5ik3bje',
              'eed6lerkta075zjg0c1qqsvea',
            ],
          },
          borderColor: '#00A996',
          borderStyle: 'dashed',
          borderWidth: 1,
          positioning: 'fixed',
          borderRadius: 0,
          responsivity: {
            verticalScaling: 'FIXED',
            horizontalScaling: 'SCALES_WITH_PARENT',
            verticalPositioning: 'TOP',
            horizontalPositioning: 'LEFT_AND_RIGHT',
          },
          initialDevice: 'desktop',
          borderPosition: 'center',
          backgroundColor: 'rgba(0,168,152, 0.10)',
          backgroundStyle: 'none',
        },
      ],
      pushGraph: {
        edges: [],
        nodeIds: ['0vsr5yweha47e8tjugsa59sgr'],
      },
      borderColor: '#BDBDBD',
      borderStyle: 'none',
      borderWidth: 1,
      positioning: 'fixed',
      borderRadius: 0,
      responsivity: {
        verticalScaling: 'FIXED',
        horizontalScaling: 'SCALES_WITH_PARENT',
        verticalPositioning: 'TOP',
        horizontalPositioning: 'CENTER',
      },
      initialDevice: 'desktop',
      borderPosition: 'center',
      backgroundColor: '#e0e0e0',
      backgroundStyle: 'none',
    },
  ],
  pushGraph: {
    edges: [],
    nodeIds: ['6kxm9ylssq5gy4vuf1zpf1b99'],
  },
  borderColor: '#BDBDBD',
  borderStyle: 'none',
  borderWidth: 1,
  imageResize: 'cover',
  positioning: 'fixedTop',
  borderRadius: 0,
  responsivity: {
    verticalScaling: 'FIXED',
    horizontalScaling: 'SCALES_WITH_PARENT',
    verticalPositioning: 'TOP',
    horizontalPositioning: 'CENTER',
  },
  initialDevice: 'desktop',
  borderPosition: 'center',
  backgroundColor: '#f5f5f5',
  backgroundStyle: 'none',
}

export default dashboardBentoBoxes
